/**
 * Component Registry for Jackstraw Apartments
 * 
 * Inherits from @vibesites-repli-sandbox/theme-avneue-no-vendor and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-repli-sandbox/theme-avneue-no-vendor/registry';
import { Hero } from './components/Hero';
import { NotFound } from './components/NotFound';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Hero,
  NotFound,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
